/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { AppService } from '../api.service';
import { BehaviorSubject } from 'rxjs';
import { ProjectsService } from './project.service';



@Injectable({
  providedIn: 'root'
})
export class DepartmentsService {
  public departments_list:any;
  public sample_departments_list:any[]=[];
  public isDepartmentLoader=true;
  page_list_mengamenu:any[]=['?isUrlc=true','department','d','space-with-work','product']
  isMegaMenu=false;
  private departmentsListSubject = new BehaviorSubject<any>([]);
  public departmentsList$ = this.departmentsListSubject.asObservable();
  private sampledepartmentsListSubject = new BehaviorSubject<any>([]);
  public sampledepartmentsList$ = this.sampledepartmentsListSubject.asObservable();
  product_count: any;
  categopry_count: any;
  category_type_count: any;
  brand_count: any;
  dealer_count: any;
  isBrowser=false;
  isSampleDepartmentLoader=false;
  samplesVisible=false;
  sampleCategorys: any[]=[];
  activesec='category';
  categoryTypes: any[]=[];
  category_slug_name: any;
  depart_slug_name: any;
  category_name: any;
  constructor(@Inject(PLATFORM_ID) private platformId: object,private http:HttpClient, private _as: AppService,private _router:Router,private project:ProjectsService) {
    this.departments_list = [];
    this._router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        // Show progress spinner or progress bar
        const url_string = this._router.url.split("/")[1];
        if(this.page_list_mengamenu.find(pl=>pl===url_string) || url_string=="" || this._router.url===`/?pId=${this.project?.selectedProject?.id}`){
          this.isMegaMenu=true;
        }else{
          this.isMegaMenu=false;
        }
      }
     
    });
  }


  getAllDepartments(){
    // this.isBrowser = isPlatformBrowser(this.platformId);
    // if(this.isBrowser){
    const url = this._as.api_base_url +'home/mega-manu-home/';
    this._as.getRequest(url, true).subscribe(
      (res:any) => {
        if(res){
          this.departmentsListSubject.next(res.main_workitem_space_list);
          if (!this.departments_list.length) {
            this.departmentsList$.subscribe((data:any)=>{
              this.departments_list=data;
            })
          }
        }
        this.product_count= res.product_count;
        this.categopry_count = res.categopry_count;
        this.category_type_count = res.category_type_count;
        this.brand_count = res.brand_count;
        this.dealer_count = res.dealer_count;
        this.isDepartmentLoader = false;
      }
    );
  // }
    // return this._as.getRequest(url, true).toPromise();
  }
  getAllSampleDCP(){
    const url = this._as.api_base_url +'home/samples-dcp/';
    this._as.getRequest(url, true).subscribe(
      (res:any) => {
        this.sample_departments_list=res;
     for(const dep of this.sample_departments_list){
      for(const sub of dep.sub_category_list){
        this.sampleCategorys.push(sub)
      }
     }
        this.isSampleDepartmentLoader = false;
      }
    )
  }
  onCategory(cat:any){
    this.depart_slug_name = this.sample_departments_list.find((sdl:any)=> sdl.sub_category_list.find((sdl:any)=>sdl.slug_name==cat.slug_name)).slug;
    this.category_slug_name=cat.id;
    this.category_name = cat.name;
    this.categoryTypes = cat.product_types;
    this.activesec = 'category-type';
 
  }
  onclose(){
    this.activesec = 'category';
    this.categoryTypes = [];
    this.samplesVisible = false;
  }
  onBack(){
    this.activesec = 'category';
    this.categoryTypes = [];
  }
  }
